function get_iow_basin_rain(){
    let geoJson = overlay_dataset["Basic_map"],
        rawData = ajax_call(publicPath + "/napi/flood/basin_rain"),
        basinRainMapping = {}
    rawData.forEach(el => {
        basinRainMapping[el["TownName"]] = el["Measurements"][0]
    })
    let thisLayer = L.geoJSON(geoJson, {
        style: rainGridStyle,
        onEachFeature: function(feature, layer){
            let thisBasinRain = basinRainMapping[feature.properties["TOWNNAME"]],
                tooltipString = thisBasinRain.TimeStamp.slice(0,16).replace("T", " ") + "<br>" + feature.properties["TOWNNAME"] + "時雨量：" + thisBasinRain.Value + "mm"
            layer.bindTooltip(tooltipString, {
                sticky: true,
                opacity: 0.8
            })
        }
    })
    let result = [thisLayer, geoJson]
    return result
}

function get_iow_basin_depth_area(){
    let rawData = ajax_call(publicPath + "/napi/flood/basin_depth_area"),
        boundsArray = [[rawData.boundary.BRLatitude, rawData.boundary.ULLongitude], [rawData.boundary.ULLatitude, rawData.boundary.BRLongitude]],
        thisLayer = L.imageOverlay("data:image/png;base64, " + rawData.picture, boundsArray)
    return thisLayer
}
